<template lang="">
    <div>
        <router-view class="mt-4"/>
    </div>
</template>
<script setup>
</script>